
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

import dayjs from 'dayjs'

export default {
    name: 'SearchDate',
    data() {
        return {
            startDate: '',
        }
    },
    watch: {
        startDate() {
            if (this.startDate !== '') {
                this.sendData()
            }
        },
    },
    beforeDestroy() {
        this.CLEAR_STORE()
    },
    methods: {
        ...mapActions('search', ['GET_SEARCH_INFO']),
        ...mapMutations('search', ['CLEAR_STORE']),
        ...mapActions('modal', ['SHOW_ALERT', 'HIDE_MODAL']),
        ...mapMutations('paging', ['RESET_STORE']),

        // 입력받은 값으로 검색
        sendData() {
            /* 
                220318 meej
                reset paging 추가
            */
            this.RESET_STORE()
            // 22.02.25 한수예
            const today = new Date();
            const year = today.getFullYear();
            const month = ('0' + (today.getMonth() + 1)).slice(-2);
            const day = ('0' + today.getDate()).slice(-2);
            const dateString = year + month + day;    

            // 현재 날짜와 비교
            if(this.startDate != null && this.startDate !== '' && this.startDate !== undefined && dateString < dayjs(this.startDate).format('YYYYMMDD')){
                 this.SHOW_ALERT({
                    content: '선택일자가 현재일자보다 클 수 없습니다.',
                })
                this.startDate = ''
            } else {
                this.GET_SEARCH_INFO({
                startDate: dayjs(this.startDate).format('YYYYMMDD'),
                endDate: dayjs(this.startDate).format('YYYYMMDD')
            })
            console.log(dayjs(this.startDate).format('YYYYMMDD'))
            }
        },
    },
}
